import { ChevronRight } from 'lucide-react'
import { cn } from '@/utils/cn'

type Props = {
  title: string
  summary: string
  onClick: () => void
  emphasized?: boolean
}

const cardBase =
  'group flex w-full items-center gap-4 rounded-xl border bg-white/[0.05] px-5 py-4 text-left shadow-sm transition-all duration-200 hover:border-[#e91e63]/45 hover:bg-white/[0.08] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#e91e63]/30'

export function PortalPjAreaHubCard({ title, summary, onClick, emphasized }: Props) {
  return (
    <button
      type='button'
      onClick={onClick}
      className={cn(cardBase, emphasized ? 'border-[#e91e63]/45' : 'border-[#e91e63]/20')}
    >
      <div className='min-w-0 flex-1'>
        <p className='text-base font-semibold text-white'>{title}</p>
        <p className='mt-2 text-sm leading-relaxed text-white/60'>{summary}</p>
      </div>
      <ChevronRight
        size={22}
        className='shrink-0 text-white/45 transition-transform group-hover:translate-x-0.5 group-hover:text-[#e91e63]'
        aria-hidden
      />
    </button>
  )
}
